import { MercerSalaryBenchmarkImporterPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useFeatures } from 'modules/core/hooks/useFeatures'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'

const MercerSalaryBenchmarkImporterPage = () => {
  const {
    company,
    access: { locale },
  } = useCurrentSession()

  const { has_dev_mercer_salary_benchmark_importer, loadingFeatures } = useFeatures([
    'dev_mercer_salary_benchmark_importer',
  ])
  const { data, loading, error } = useQuery(MercerSalaryBenchmarkImporterPageDocument, {
    fetchPolicy: 'network-only',
  })

  const canImportResources = data?.universalImporter._policies.importResources.can
  const authorized = Boolean(
    canImportResources && !loadingFeatures && has_dev_mercer_salary_benchmark_importer
  )

  return (
    <ResponsivePage.Body
      authorized={authorized}
      showHeader={false}
      loading={loadingFeatures || loading}
      error={error}
    >
      <NuvoImporter
        importType="mercer_salary_benchmark_importer"
        locale={locale}
        companyId={company.id}
        customFinishNavigation="/settings/import-history"
      />
    </ResponsivePage.Body>
  )
}

export default MercerSalaryBenchmarkImporterPage
